import type { LicenseCriteria, Organisation, XeroInvoiceState } from '../../types'
import { ConfirmDialog } from './ConfirmDialog'
import { CreateLicenseFromGatesModal } from './CreateLicenseFromGatesModal'
import { EditLicenseModal } from './EditLicenseModal'
import { ExtendModal } from './ExtendModal'
import type { LicensesActions, LicensesModalSlots } from './use-licenses-tab-state'

interface LicensesModalsProps {
  modals: LicensesModalSlots
  actions: LicensesActions
  organisations: Organisation[]
  xeroInvoices: XeroInvoiceState[]
  licenseCriteria: LicenseCriteria[]
  onRefresh: () => Promise<void>
}

export function LicensesModals(props: LicensesModalsProps): React.ReactElement {
  const { modals, actions, organisations, xeroInvoices, licenseCriteria, onRefresh } = props
  return (
    <>
      {modals.showCreateModal && (
        <CreateLicenseFromGatesModal
          organisations={organisations}
          xeroInvoices={xeroInvoices}
          licenseCriteria={licenseCriteria}
          onClose={() => {
            modals.setShowCreateModal(false)
          }}
          onCreate={actions.handleCreateLicenseFromGates}
          onRefresh={onRefresh}
        />
      )}
      {modals.editingLicense && (
        <EditLicenseModal
          license={modals.editingLicense}
          onClose={() => {
            modals.setEditingLicense(null)
          }}
          onSave={actions.handleUpdateLicense}
        />
      )}
      {modals.extendingLicense && (
        <ExtendModal
          license={modals.extendingLicense}
          onClose={() => {
            modals.setExtendingLicense(null)
          }}
          onExtend={actions.handleExtendLicense}
        />
      )}
      {modals.activatingLicense && (
        <ConfirmDialog
          title="Activate License"
          message={`Are you sure you want to activate the license "${modals.activatingLicense.licenseKey}"? This will allow the organisation to use the software.`}
          confirmLabel="Activate"
          confirmStyle="success"
          onClose={() => {
            modals.setActivatingLicense(null)
          }}
          onConfirm={actions.handleActivateLicense}
        />
      )}
      {modals.suspendingLicense && (
        <ConfirmDialog
          title="Suspend License"
          message={`Are you sure you want to suspend the license "${modals.suspendingLicense.licenseKey}"? The organisation will no longer be able to use the software.`}
          confirmLabel="Suspend"
          confirmStyle="warning"
          onClose={() => {
            modals.setSuspendingLicense(null)
          }}
          onConfirm={actions.handleSuspendLicense}
        />
      )}
    </>
  )
}
